<div class="header">
  <div class="item">
    @let logoSrc = src();
    @if (logoSrc) {
      <fol-img [src]="logoSrc" [title]="brandImageName()" />
    }
  </div>
  <div class="item"></div>
</div>
